export enum PortaitMutationTypes {
  SET_AIR = 'SET_AIR',
  SET_LIGHT = 'SET_LIGHT',
}
